import { Navigate } from 'react-router-dom';

import AktivitetPresentation from 'components/aktivitetPresentation/AktivitetPresentation';
import InventeringPreliminarPresentation from 'components/aktivitetPresentation/inventering/InventeringPreliminarPresentation';
import InventeringRegistration from 'components/aktivitetRegistrering/inventering/inventeringRegistration/InventeringRegistration';
import SkyddsklassningRegistration from 'components/aktivitetRegistrering/skyddsklassning/SkyddsklassningRegistration';
import BebyggelseobjektHistoriskPresentation from 'components/bebyggelseobjekt/BebyggelseobjektHistoriskPresentation';
import BebyggelseobjektPresentation from 'components/bebyggelseobjekt/BebyggelseobjektPresentation';
import NotFound from 'components/notFound/NotFound';
import PagaendeAktiviteter from 'components/pagaendeAktiviteter/PagaendeAktiviteter';
import BebyggelseobjektSearchResult from 'components/search/bebyggelseobjekt/BebyggelseobjektSearchResult';
import SearchBebyggelseobjektForm from 'components/search/bebyggelseobjekt/SearchBebyggelseobjektForm';
import InventeringSearchResult from 'components/search/inventering/InventeringSearchResult';
import SearchInventeringForm from 'components/search/inventering/SearchInventeringForm';
import UtkastPresentation from 'components/utkast/utkastPresentation/UtkastPresentation';
import UtkastRegistration from 'components/utkast/utkastRegistration/UtkastRegistration';

import { AuthorityRolesEnum, SkyddsklassningstypEnum } from 'enums';

export const AppRoutes = (rolesInSelectedOrganisation: Array<AuthorityRolesEnum>) => {
  const granskareRoutes = rolesInSelectedOrganisation.includes(AuthorityRolesEnum.GRANSKARE)
    ? [
        { path: '/utkast/:id', element: <UtkastPresentation /> },
        { path: '/inventering/:id/preliminar', element: <InventeringPreliminarPresentation /> }
      ]
    : [];

  const bebyggelseregistrerareRoutes = rolesInSelectedOrganisation.includes(AuthorityRolesEnum.BEBYGGELSEREGISTRERARE)
    ? [
        { path: '/aktiviteter', element: <PagaendeAktiviteter /> },
        { path: '/utkast/:id', element: <UtkastPresentation /> },
        { path: '/utkast/:id', element: <UtkastPresentation /> },
        { path: '/utkast/:id', element: <UtkastPresentation /> },
        { path: '/utkast/:id', element: <UtkastPresentation /> },
        { path: '/utkast/:id', element: <UtkastPresentation /> },
        { path: '/utkast/:id', element: <UtkastPresentation /> },
        { path: '/utkast/:id/redigera', element: <UtkastRegistration /> },
        { path: '/inventering', element: <InventeringRegistration /> },
        { path: '/inventering/:id/redigera', element: <InventeringRegistration /> },
        { path: '/inventering/:id/preliminar', element: <InventeringPreliminarPresentation /> }
      ]
    : [];

  const SBMRoutes = rolesInSelectedOrganisation.includes(AuthorityRolesEnum.SBM_HANDLAGGARE)
    ? [
        { path: '/aktiviteter', element: <PagaendeAktiviteter /> },
        { path: '/utkast/:id', element: <UtkastPresentation /> },
        { path: '/utkast/:id/redigera', element: <UtkastRegistration /> },
        {
          path: '/skyddsklassning/havning-av-sbm/:id',
          element: (
            <SkyddsklassningRegistration
              skyddsklassningstyp={SkyddsklassningstypEnum.HAVNING_AV_STATLIGT_BYGGNADSMINNE}
            />
          )
        },
        {
          path: '/skyddsklassning/agarbyte/:id',
          element: (
            <SkyddsklassningRegistration
              skyddsklassningstyp={SkyddsklassningstypEnum.AGARBYTE_STATLIGT_BYGGNADSMINNE}
            />
          )
        },
        {
          path: '/skyddsklassning/revidering/:id',
          element: (
            <SkyddsklassningRegistration
              skyddsklassningstyp={SkyddsklassningstypEnum.REVIDERING_AV_STATLIGT_BYGGNADSMINNE}
            />
          )
        },
        {
          path: '/skyddsklassning',
          element: (
            <SkyddsklassningRegistration
              skyddsklassningstyp={SkyddsklassningstypEnum.BESLUT_OM_STATLIGT_BYGGNADSMINNE}
            />
          )
        }
      ]
    : [];

  const openRoutes = [
    { path: '/bebyggelseobjekt/:id', element: <BebyggelseobjektPresentation /> },
    { path: '/bebyggelseobjekt/:id/version/:version', element: <BebyggelseobjektHistoriskPresentation /> },
    { path: '/aktivitet/:id', element: <AktivitetPresentation /> },
    { path: '/sok-inventering', element: <SearchInventeringForm /> },
    { path: '/sok-inventering/resultat/*', element: <InventeringSearchResult /> },
    { path: '/sok-bebyggelseobjekt', element: <SearchBebyggelseobjektForm /> },
    { path: '/sok-bebyggelseobjekt/resultat/*', element: <BebyggelseobjektSearchResult /> },
    { path: '*', element: <Navigate replace to="/404" /> },
    { path: '/404', element: <NotFound /> }
  ];

  return [...granskareRoutes, ...bebyggelseregistrerareRoutes, ...SBMRoutes, ...openRoutes].filter(
    (route, index, self) => index === self.findIndex((r) => r.path === route.path)
  );
};
